<template>
  <div id="app" class="infinite-wrapper">
    <vue-progress-bar></vue-progress-bar>
    <notifications group="main" />
    <Frame v-if="loggedin && user" />
    <Login v-else />
  </div>
</template>

<script>
import Data from './main';
import Login from './components/login.vue';
import Frame from './components/frame.vue';
import VueCookies from 'vue-cookies';
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
Vue.prototype.$axios = axios;
Vue.prototype.$moment = moment;

Vue.use(VueCookies);
VueCookies.config('7d');

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
	color: '#00aced',
	failedColor: '#874b4b',
	thickness: '5px',
	transition: {
		speed: '0.2s',
		opacity: '0.6s',
		termination: 300,
	},
	autoRevert: true,
	location: 'top',
	inverse: false,
});


export default {
	name: 'app',
	data() {
		return {
			loggedin: false,
			user: false
		};
	},
	created() {
    this.$axios.defaults.baseURL = process.env.VUE_APP_API_URL;
		this.$nextTick(function() {
			this.loginInit();
			this.loadUser();
		});

		this.$root.$on('is_loggedin', (loggedin) => {
			this.loggedin = loggedin;
			this.loginInit();
			this.loadUser();
		});
	},

	methods: {
		loadUser(){
			this.$Progress.start();

			this.$axios
				.get('/user/self')
				.then((response) => {
					Data.user = response.data;
					this.user = response.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=> this.$Progress.finish() );
		},

		loginInit() {
			if (this.$cookies.get('user_session')) {
				this.loggedin = true;
				this.$axios.defaults.headers.common = {
					'Authorization': 'Bearer ' + this.$cookies.get('user_session'),
					'Accept': 'application/json',
				};
			}
		},
	},
	components: {
		Login,
		Frame,
	},
};
</script>

<style>
.vue-notification{
  padding:15px !important;
  font-size: 16px !important;
  margin-top: 10px !important;
}
</style>
